import React, { useEffect } from "react";
import { Modal, Form as FormLayout } from "react-bootstrap";
import { useMigrateToGroupMutation } from "../../../../../../../../redux/apiSlice";
import cogoToast from "cogo-toast";
import { Formik, Form } from "formik";
import * as Yup from "yup"
import SelectInput from "../../../../../../../../app/modules/Common/components/select-input";
import { COUNTRIES } from "../../../../../../../util/constants/Countries"

export const ChangeNationalityModal = ({ showChangeNationalityModal, onHide, details }) => {
    const [
        changeNationality, // This is the mutation trigger
        {
            isLoading: isChanging,
            isSuccess: changedSuccessfully,
        }, // This is the destructured mutation result
    ] = useMigrateToGroupMutation()

    /* Close Modal on Successful Deletion */
    useEffect(() => {
        if (changedSuccessfully) {
            cogoToast.success("Created 'Change Nationality' Action Successfully")
            onHide()
        }
    }, [changedSuccessfully, onHide]);

    /* Change User Group */
    const onSubmit = (values) => {
        changeNationality({
            userId: details?.basic?.userId,
            nationality: values?.nationality,
            username: details?.basic?.username,
            meta: { userGroup: details?.userGroup },
        })
    }

    return (
        <Modal
            show={showChangeNationalityModal}
            onHide={onHide}
            aria-labelledby="contained-modal-title-vcenter"
            backdrop={isChanging ? "static" : true}
            keyboard={!isChanging}
        >
            <Formik
                initialValues={{ nationality: details?.nationality }}
                validationSchema={
                    Yup.object({ nationality: Yup.string().required("required") })
                }
                onSubmit={(values) => onSubmit(values)}
            >
                <Form>
                    <Modal.Header>
                        <Modal.Title id="contained-modal-title-vcenter">
                            {`Change ${details?.basic?.username}'s Nationality`}
                        </Modal.Title>
                        <button type="button" className="close" onClick={onHide}>
                            <span aria-hidden="true" className="d-block">×</span>
                            <span className="sr-only">Close</span>
                        </button>
                    </Modal.Header>

                    <Modal.Body style={{ maxHeight: "calc(100vh - 300px)", overflow: "auto" }}>
                        <FormLayout.Row>
                            <SelectInput
                                label="Select Country*"
                                name="nationality"
                                options={COUNTRIES}
                            />
                        </FormLayout.Row>
                    </Modal.Body>
                    <Modal.Footer>
                        <button
                            type="button"
                            onClick={onHide}
                            disabled={isChanging}
                            className="btn btn-light btn-elevate px-4"
                        >
                            Cancel
                        </button>
                        <button
                            type="submit"
                            disabled={isChanging}
                            className="btn btn-primary btn-elevate px-4 ml-4"
                        >
                            Submit
                        </button>
                    </Modal.Footer>
                </Form>
            </Formik>
        </Modal>
    );
}
